/* eslint-disable react/forbid-elements */
import * as React from 'react';
import * as styles from './Loader.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Loader() {
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: /*#__PURE__*/_jsxs("svg", {
      className: styles['loader'],
      viewBox: "0 0 40 40",
      children: [/*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsxs("linearGradient", {
          id: "gradient-1",
          gradientUnits: "userSpaceOnUse",
          y1: "30",
          x2: "40",
          y2: "30",
          children: [/*#__PURE__*/_jsx("stop", {
            offset: "0",
            stopColor: "#0076eb"
          }), /*#__PURE__*/_jsx("stop", {
            offset: "1",
            stopColor: "#ffffff",
            stopOpacity: "0"
          })]
        })
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#gradient-1)",
        d: "M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z"
      })]
    })
  });
}